import * as TK from 'components/search/SearchForm/translations/constants';
import { Translations } from 'translations/types';

export const searchFormEnUsLocale: Translations = {
  [TK.SEARCH_FORM_PLACEHOLDER]: 'Enter to search',
  [TK.SEARCH_FORM_SUBMIT_BUTTON_LABEL]: 'Search',
};
